import { useState } from "react";
import { ghostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import { useAuth } from "@/contexts/AuthContext";
import { deleteQcReport } from "@/lib/manufacturing/qcDashboardClient";

export function QcReportDeleteButton({
  sessionId,
  label,
  onDeleted,
}: {
  sessionId: string;
  label: string;
  onDeleted: () => void;
}) {
  const auth = useAuth();
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (!auth.hasRole("platform_dev", "owner", "org_owner")) return null;

  async function remove() {
    setBusy(true);
    setError(null);
    const res = await deleteQcReport(sessionId);
    setBusy(false);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    setConfirming(false);
    onDeleted();
  }

  if (!confirming) {
    return (
      <button type="button" className={`${ghostBtnClass} shrink-0`} onClick={() => setConfirming(true)}>
        Delete
      </button>
    );
  }

  return (
    <div className="w-full min-w-0 basis-full rounded-lg border border-gray-200 bg-white p-2 text-left text-sm text-gray-800 dark:border-zinc-600 dark:bg-zinc-900 dark:text-zinc-100">
      <p className="break-words">Delete {label} and its photos? This cannot be undone.</p>
      <div className="mt-2 flex flex-wrap gap-2">
        <button type="button" className={ghostBtnClass} disabled={busy} onClick={() => void remove()}>
          {busy ? "Deleting…" : "Delete report"}
        </button>
        <button type="button" className={ghostBtnClass} disabled={busy} onClick={() => setConfirming(false)}>
          Cancel
        </button>
      </div>
      {error ? <p className="mt-1 break-words text-red-700 dark:text-red-300">{error}</p> : null}
    </div>
  );
}
